export default __webpack_public_path__ + "6b5eb0a6b1f7477d19237ced8c297d53.svg";